import { cn } from '../../lib/cn';
import { Check } from 'lucide-react';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helper?: string;
}

export function Checkbox({
  label,
  helper,
  className,
  ...props
}: CheckboxProps) {
  const id = props.id || `checkbox-${Math.random().toString(36).slice(2, 9)}`;

  return (
    <label
      htmlFor={id}
      className={cn(
        'flex cursor-pointer items-start gap-3 rounded-lg p-2 transition-colors hover:bg-slate-50 dark:hover:bg-slate-800/50',
        className
      )}
    >
      <div className="relative flex h-6 w-6 shrink-0 items-center justify-center">
        <input
          id={id}
          type="checkbox"
          className="peer h-6 w-6 cursor-pointer appearance-none rounded-md border-2 border-slate-300 bg-white transition-colors checked:border-park-600 checked:bg-park-600 focus-visible:ring-2 focus-visible:ring-park-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-600 dark:bg-slate-800"
          {...props}
        />
        <Check className="pointer-events-none absolute h-4 w-4 text-white opacity-0 peer-checked:opacity-100" strokeWidth={3} />
      </div>
      {(label || helper) && (
        <div className="flex flex-col">
          {label && (
            <span className="text-sm font-medium text-slate-900 dark:text-slate-100">{label}</span>
          )}
          {helper && (
            <span className="text-xs text-slate-500 dark:text-slate-400">{helper}</span>
          )}
        </div>
      )}
    </label>
  );
}
